import "./src/styles/bootstrap.css"
import "./src/styles/owl.carousel.css"
import "./src/styles/owl.theme.default.min.css"
import "./src/styles/animate.css"
import "./src/styles/style.css"
import "./src/styles/global.css"

export const onClientEntry = () => {
  const loadScript = (src: string) => {
    return new Promise<void>((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.type = "text/javascript";
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.body.appendChild(script);
    });
  };

  const loadScripts = async () => {
    try {
      // Load scripts in the correct order
      await loadScript("/js/jquery.min.js"); // Load jQuery first
      await loadScript("/js/bootstrap.js"); // Then Bootstrap
      await loadScript("/js/owl.carousel.js"); // Then Owl Carousel
      await loadScript("/js/wow.min.js"); // Then WOW.js
      await loadScript("/js/main.js"); // Then your main.js
    } catch (error) {
      console.error(error);
    }
  };

  // Trigger script loading
  loadScripts();
};